import React from 'react';
import PropTypes from 'prop-types';
import './OrderPanelHeader.css';

const OrdersPanelHeader = ({ title, filterComponent }) => {
  return (
    <div className="OrdersPanelHeader">
      <h4 className="OrdersPanelHeader__title">{title}</h4>
      <div className="OrdersPanelHeader__filter">{filterComponent}</div>
    </div>
  );
};

OrdersPanelHeader.propTypes = {
  title: PropTypes.string.isRequired,
  filterComponent: PropTypes.node,
};

OrdersPanelHeader.defaultProps = {
  filterComponent: null,
};

export default OrdersPanelHeader;



// WEBPACK FOOTER //
// ./src/modules/orders/components/OrderPanelHeader/OrderPanelHeader.jsx